import type { PortalLocale } from '@worldcoo/monolith/portals';

/**
 * The single source of published locales. Order is load-bearing: the first is `x-default`, the locale
 * the pathless URL serves. Five of `portalLocales`' ten, gated by review and support, not strings. No
 * JSX here, or the flags land in the router's chunk.
 */
export const wwwLocales = ['es', 'en', 'ca', 'fr', 'it'] as const satisfies readonly PortalLocale[];

export type WwwLocale = (typeof wwwLocales)[number];
